import { useEffect, useState } from "react";
import { PagingType, QueryParam } from "../api";
import { ewaiverApi } from "../api/ewaiver.service";

export interface EwaiverType {
  event_id: string;
  event_name: string;
  event_name_vi: string;
  is_have_online_checkin: number;
  start_checkin_online_date: string;
  end_checkin_online_date: string;
}

export interface EwaiverQuery extends QueryParam {}

interface UseEwaiverProps {
  initQuery: EwaiverQuery;
}

export const useEwaiver = (page: number, { initQuery }: UseEwaiverProps) => {
  const [data, setData] = useState<EwaiverType[]>([]);
  const [paging, setPaging] = useState<PagingType>({
    current_page: 0,
    total_item: 0,
    total_page: 0,
    total: 0,
  });
  const [query, setQuery] = useState<EwaiverQuery>(initQuery);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await ewaiverApi.findAll(page, query);
      const data = res?.data;

      setData(data?.data?.data);
      setPaging(data?.data?.paging);
    } catch (error: any) {
      console.log("Get ewaiver list failed:", error);

      setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, query]);

  return { data, paging, fetchData, loading, error, setQuery, query };
};
